import { createListenerMiddleware, configureStore, createSlice} from '@reduxjs/toolkit';
import owners from './common/owners'
import message_threads, { useMessageThreads } from './common/threads'
import users from './common/users'
import owner_groups from './common/owner_groups'

import messages, { registerListeners as registerMessageListeners } from './common/messages'
import owner_users, { registerListeners as registerOwnerUserListeners } from './common/owner_users'
import unread, { registerListeners as registerUnreadListeners } from './lists/unread'

import { registerListeners as registerHeartbeats } from './heartbeat';

const listenerMiddleware = createListenerMiddleware()

const init = createSlice({
  name: 'init',
  initialState: {},
  reducers: {
    init: (state) => {}
  }
})

registerHeartbeats(listenerMiddleware, init.actions.init)
registerMessageListeners(listenerMiddleware, init.actions.init)
registerOwnerUserListeners(listenerMiddleware, init.actions.init)
registerUnreadListeners(listenerMiddleware, init.actions.init)

const store = configureStore({
  reducer: {
    init,
    owners,
    message_threads,
    messages,
    users,
    owner_groups,
    owner_users,
    unread
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().prepend(listenerMiddleware.middleware)
})

store.dispatch(init.actions.init())

export default store